import { TypeOf } from "../enum/type-of";

export class LocalStorage {

	public static set(key: string, data: any): void {
		if (!data) {
			return localStorage.removeItem(key);
		}
		if (typeof data === TypeOf.STRING) {
			return localStorage.setItem(key, data);
		}
		if (typeof data === TypeOf.NUMBER) {
			return localStorage.setItem(key, data.toString());
		}
		localStorage.setItem(key, JSON.stringify(data));
	}

	public static push(key: string, value: any) {
		let local = localStorage.getItem(key);
		let localParsed = null;
		if (local) {
			localParsed = JSON.parse(local);
		}
		if (!local || !localParsed) {
			localParsed = [];
		}
		localParsed.push(value);
		localStorage.setItem(key, JSON.stringify(localParsed));
	}

	public static removeItem(key: string, value: any) {
		const item = localStorage.getItem(key);
		if (!item?.length) {
			return;
		}
		let local = JSON.parse(item);
		if (local) {
			local = [];
		}
		local?.splice(local.indexOf(value), 1);
		if (!local?.length) {
			return localStorage.removeItem(key);
		}
		if (!local) {
			return;
		}
		localStorage.setItem(key, JSON.stringify(local));
	}

	public static isEmpty(key: string): boolean {
		return (localStorage.getItem(key) === null || localStorage.getItem(key) === undefined) && localStorage.getItem(key) !== '0';
	}

	public static get(key: string, defaultValue?: any): any {
		try {
			const local = localStorage.getItem(key);
			if (!local) {
				return defaultValue ?? null;
			}
			if (!isNaN(+local)) {
				return +local;
			}
			if (
				(local.indexOf('[') == 0 && local.lastIndexOf(']') >= 0) ||
				(local.indexOf('{') == 0 && local.lastIndexOf('}') >= 0)
			) {
				return JSON.parse(local);
			}
			return local;
		} catch (error) { }
		return null;
	}

	public static getItemAndRemove(key: string, defaultValue?: any): any {
		const item = this.get(key, defaultValue);
		if (item) localStorage.removeItem(key);
		return item;
	}

	public static exists(key: string): boolean {
		return !!localStorage.getItem(key);
	}

	public static removeAt(keys: string[]): void {
		keys.forEach(key => localStorage.removeItem(key));
	}

	public static remove(key: string): void {
		localStorage.removeItem(key);
	}

	public static clear(): void {
		localStorage.clear();
	}
}
